import { useTranslation } from "react-i18next"

import {
  TimelineContainer,
  TimelineItem,
} from "@/components/commons/app-timeline"
import type { PaymentMethodNameEnum } from "@/enums"
import { CycleStatusEnum } from "@/enums/subscriptions"
import { DateHelper } from "@/utils"

import {
  getCycleStatusInfo,
  isCancelPaymentMethodByType,
} from "./SubscriptionsHelper"
interface SubscriptionEventTimelineProps {
  items: EventType[]
  paymentMethod?: PaymentMethodNameEnum
}
export const SubscriptionEventTimeline = ({
  items,
  paymentMethod,
}: SubscriptionEventTimelineProps) => {
  const { t } = useTranslation()
  return (
    <TimelineContainer data={items}>
      {items?.map((item, index) => {
        const isCancelPaymentMethod =
          isCancelPaymentMethodByType(paymentMethod)
        const spaceBetween = (index + 1) * 70
        const statusInfo = getCycleStatusInfo(
          item.status as CycleStatusEnum,
          t,
          paymentMethod
        )

        let tooltipMessage = item?.description
        if (
          isCancelPaymentMethod &&
          [
            CycleStatusEnum.REVERSED,
            CycleStatusEnum.PROCESSING_REVERSING,
          ].includes(item.status as CycleStatusEnum) &&
          tooltipMessage
        ) {
          tooltipMessage = tooltipMessage.replaceAll(
            /estornado/gi,
            "cancelado"
          )
        }

        return (
          <TimelineItem
            key={index}
            colors={{ bg: statusInfo.bgColor }}
            spaceBetween={spaceBetween}
            tooltip={tooltipMessage}
          >
            <p className="text-[11px]">
              {statusInfo.label}
            </p>
            <p className="text-[10px]">
              {DateHelper.format(
                item.createdAt,
                "dd/MM/yyyy - HH:mm:ss"
              )}
            </p>
          </TimelineItem>
        )
      })}
    </TimelineContainer>
  )
}
